import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import logo1 from "../../assets/images/brand-logos/desktop-dark.png";
import Img from "../../assets/images/flags/us_flag.jpg";
import Img1 from "../../assets/images/flags/french_flag.jpg";
import Spinner from "../../components/Spinner/spinner";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import api from "../../api";
const Recover_password = () => {
  const [languageData, setLanguageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showSpinner, setShowSpinner] = useState(false);
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({
    email: "",
  });
  const [cookieLang, setCookieLang] = useState("");

function setLanguage(lang) {
    document.cookie = `lang=${lang}; path=/; max-age=31536000`;
    localStorage.setItem("lang", lang);
   // window.location.reload();
  }

  useEffect(() => {
    const start = Date.now();

    const spinnerTimeout = setTimeout(() => {
      setShowSpinner(true);
    }, 500);

    const fetchTimeout = setTimeout(() => {
      setLoading(false);
      const elapsed = Date.now() - start;
      if (elapsed < 500) {
        clearTimeout(spinnerTimeout);
      }
    }, 2000);

    return () => {
      clearTimeout(spinnerTimeout);
      clearTimeout(fetchTimeout);
    };
  }, []);

   useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      setCookieLang(cookieLang);
      import(`../../lang/forget-password/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data.default);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.error("Language cookie 'lang' not found.");
    }
  }, []);
  const getDevice = () => {
    const ua = navigator.userAgent;

    if (/mobile/i.test(ua)) return "Mobile";
    if (/tablet/i.test(ua)) return "Tablet";
    return "Desktop";
  };
  const getBrowserInfo = () => {
    const ua = navigator.userAgent;
    let browser = "Unknown";
    let version = "Unknown";

    if (ua.includes("Chrome")) {
      browser = "Chrome";
      version = ua.match(/Chrome\/([\d.]+)/)?.[1];
    } else if (ua.includes("Firefox")) {
      browser = "Firefox";
      version = ua.match(/Firefox\/([\d.]+)/)?.[1];
    } else if (ua.includes("Safari")) {
      browser = "Safari";
      version = ua.match(/Version\/([\d.]+)/)?.[1];
    } else if (ua.includes("Edg")) {
      browser = "Edge";
      version = ua.match(/Edg\/([\d.]+)/)?.[1];
    }

    return { browser, version };
  };
  const getOSInfo = () => {
    const ua = navigator.userAgent;
    let os = "Unknown";
    let version = "Unknown";

    if (ua.includes("Windows")) {
      os = "Windows";
      version = ua.match(/Windows NT ([\d.]+)/)?.[1];
    } else if (ua.includes("Mac OS")) {
      os = "OS X";
      version = ua.match(/Mac OS X ([\d_]+)/)?.[1]?.replace(/_/g, ".");
    } else if (ua.includes("Android")) {
      os = "Android";
      version = ua.match(/Android ([\d.]+)/)?.[1];
    } else if (ua.includes("iPhone")) {
      os = "iOS";
      version = ua.match(/OS ([\d_]+)/)?.[1]?.replace(/_/g, ".");
    }

    return { os, version };
  };

  async function getUserCountryOnce() {
    const cached = localStorage.getItem("userCountry");
    if (cached) return JSON.parse(cached);

    try {
      const ipRes = await fetch("https://api.ipify.org?format=json");
      const ipData = await ipRes.json();

      const lookupRes = await fetch(
        "https://builder.leadsy.pro/lookup_api/v1/" + ipData.ip,
      );

      const lookupData = await lookupRes.json();
      const data = lookupData?.data || {};

      const result = {
        ip: data.ip || ipData.ip,
        city: data.city || "Unknown City",
        region: data.region || "Unknown Region",
        country: data.country || "Unknown",
        timezone:
          data.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
      const country = lookupData?.data?.country || "us";
      localStorage.setItem("userCountry", JSON.stringify(result));

      return result;
    } catch (e) {
      return {
        ip: "",
        city: "Unknown City",
        region: "Unknown Region",
        country: "US",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
    }
  }
  const { browser, version } = getBrowserInfo();
  const { os, version: osVersion } = getOSInfo();
  const init = async () => {
    const locationData = await getUserCountryOnce();
         const leadId = Cookies.get(process.env.REACT_APP_LEAD_ID_PLATFORM) || Cookies.get(process.env.REACT_APP_LEAD_ID);
    const payload = {
      url: window.location.href,
      device: getDevice(),
      ip_address: locationData.ip,
      browser_data: navigator.userAgent,
        ...(leadId ? { lead_id: leadId } : {}),
      details: {
        browser: browser,
        browser_version: version,
        operating_system: os,
        operating_system_version: osVersion,
        location: `${locationData.region}`,
        city: locationData.city,
        region: locationData.region,
        country: locationData.country,
        timezone: locationData.timezone,
        use_vpn: false,
      },
    };
    return payload;
  };

  async function updateSessionLead(lead_id, payload) {
    try {
      const response = await api.post(
        `${process.env.REACT_APP_BASE_URL}/tracking/sessions/add`,
        {
          ...payload,
          lead_id: lead_id,
        },
      );
      const data = response.data;
      Cookies.set(`${process.env.REACT_APP_SESSION_ID}`, String(data.data.id));
      Cookies.set(
        `${process.env.REACT_APP_LEAD_ID}`,
        String(data.data.lead_id),
      );
      Cookies.set(
        `${process.env.REACT_APP_SESSION_ID}_expires`,
        String(Date.now()),
      );
      return response;
    } catch (err) {
      console.error("Update session error:", err);
      return null;
    }
  }
   const getSessionId = async (payload) => {
      let sessionId = Cookies.get(process.env.REACT_APP_SESSION_ID);
  
      const expiredSession = Cookies.get(
        `${process.env.REACT_APP_SESSION_ID}_expires`,
      );
  
      const isExpired =
        !expiredSession || Date.now() - Number(expiredSession) > 3600000;
  
      if (!sessionId || isExpired) {
        const leadId =
          Cookies.get(process.env.REACT_APP_LEAD_ID_PLATFORM) ||
          Cookies.get(process.env.REACT_APP_LEAD_ID);
  
        const response = await updateSessionLead(leadId, payload);
  
        if (!response) return null;
  
        sessionId = String(response.data.data.id);
      }
  
      return sessionId;
    };
 const trackInteraction = async (
    action,
    element,
    element_value,
    time_start = new Date().toISOString(),
    time_end = new Date().toISOString(),
    payload = null,
  ) => {
    try {
      const sessionId = await getSessionId(payload);

      if (!sessionId) return;

      await api.post(
        `${process.env.REACT_APP_BASE_URL}/tracking/interactions/add`,
        {
          session_id: sessionId,
          action,
          element,
          element_value: element_value || "",
          time_start,
          time_end,
        },
      );
    } catch (error) {
      console.error("Tracking error:", error);
    }
  };
  useEffect(() => {
    const runTracking = async () => {
      const payload = await init();
      await getSessionId(payload);
      await trackInteraction(
        "view",
        "page_load",
        window.location.href,
        new Date().toISOString(),
        new Date().toISOString(),
        payload,
      );
    };

    runTracking();
  }, []);

  useEffect(() => {
    const handleSubmit = async (e) => {
      const form = e.target;
      const now = new Date().toISOString();
      await trackInteraction(
        "submit",
         form.name,
        now,
        now
      );
    };

    const handleClick = async (e) => {
      const button = e.target.closest("button, a");
      if (!button) return;
      const now = new Date().toISOString();
      await trackInteraction(
        "click",
         button.dataset.interaction,
        button.textContent,
        now,
        now
      );
    };

    const handleBlur = async (e) => {
      if (!["INPUT", "SELECT", "TEXTAREA"].includes(e.target.tagName)) return;
      const now = new Date().toISOString();
      await trackInteraction(
        "input",
          e.target.name,
      e.target.value,
        now,
        now
      );
    };

    document.addEventListener("submit", handleSubmit);
    document.addEventListener("click", handleClick);
    document.addEventListener("blur", handleBlur, true);

    return () => {
      document.removeEventListener("submit", handleSubmit);
      document.removeEventListener("click", handleClick);
      document.removeEventListener("blur", handleBlur, true);
    };
  }, []);
  
  if (!languageData) {
    return <div></div>;
  }

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      email: "",
    };

    if (!email.trim()) {
      newErrors.email = languageData["email-error"];
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      setErrors({
        ...errors,
      });
    }
  };
  const languageConfig = {
  fr: {
    flag: Img1,
  },
  en: {
    flag: Img,
  }
};
const availableLanguages = (process.env.REACT_APP_LANGUAGES).split(",").map((lang) => lang.trim()).filter(Boolean);

  return (
    <>
      <div
        className="header-element country-selector position-absolute top-0 end-0 p-3"
        style={{ zIndex: 1050 }}
      >
        <a data-interaction="lang_button"
          aria-label="anchor"
          href="javascript:void(0);"
          data-bs-toggle="dropdown"
          data-bs-auto-close="outside"
        >
          <i className="bx bx-globe fs-3 text-black"></i>
        </a>
      <ul
  className="dropdown-position absolute main-header-dropdown dropdown-menu border-0 dropdown-menu-end"
  data-popper-placement="none"
>
  {availableLanguages.map((lang) => {
    const config = languageConfig[lang];

    if (!config) return null;

    return (
      <li key={lang}>
        <a
          href="#"
          data-interaction="lang"
          className="dropdown-item d-flex align-items-center"
          onClick={(e) => {
            e.preventDefault();
            setLanguage(lang);
          }}
        >
          <span className="avatar avatar-xs lh-1 me-2">
            <img src={config.flag} alt={lang} />
          </span>

         {languageData?.lang?.[lang]}
        </a>
      </li>
    );
  })}
</ul>
      </div>
      {loading ? (
        showSpinner && <Spinner />
      ) : (
        <div className="page error-bg" id="particles-js">
          <div className="error-page">
            <div className="container-lg">
              <div className="row justify-content-center align-items-center authentication authentication-basic h-100">
                <div className="col-xxl-4 col-xl-5 col-lg-5 col-md-6 col-sm-8 col-12">
                  <div className="my-5 d-flex justify-content-center">
                 
                      <img src={logo} alt="logo" className="desktop-logo" />
                      <img src={logo1} alt="logo" className="desktop-dark" />
                  
                  </div>
                  <div
                    className="card custom-card rectangle2"
                    style={{
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                      width: "120%",
                    }}
                  >
                    <div className="card-body p-sm-5 p-3 rectangle3">
                      <div className="text-center">
                        <h4 className="mb-1 fs-20" style={{ color: "grey" }}>
                          {languageData.title}
                        </h4>
                       

                        <div className="btn-list d-flex flex-column gap-3 mt-5">
                          <form onSubmit={handleSubmit}>
                            <div className="form-group text-start">
                              <label for="exampleInputEmail1" className="">
                                {languageData.email}
                              </label>
                              <input
                                type="email"
                                name="email"
                                className={`form-control mt-2 ${
                                  errors.email ? "is-invalid" : ""
                                }`}
                                id="exampleInputEmail1"
                                aria-describedby="emailHelp"
                                onChange={(e) => setEmail(e.target.value)}
                              />
                              {errors.email && (
                                <div className="invalid-feedback text-start">
                                  {errors.email}
                                </div>
                              )}
                            </div>

                            <div
                              className="d-flex justify-content-between mt-5"
                              style={{ width: "100%" }}
                            >
                              <Link to="/signin" className="btn"  data-interaction="cancel_recover_password" style={{ backgroundColor: "#808080",
                                    borderColor: "#808080",
                                    color: "white",
                                    width: "100%" }}>
                              {languageData.cancel}
                              </Link>

                              <button  data-interaction="confirm_recover_password"
                                type="submit"
                                className="btn btn-primary"
                                style={{
                                  backgroundColor: "#FF6347",
                                  borderColor: "#FF6347",
                                  width: "100%",
                                }}
                              >
                                {languageData.button}
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Recover_password;
